import React from 'react';
import {
  Box,
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Paper,
  Typography,
  InputLabel,
} from '@mui/material';

const Step6PertanyaanTambahan = ({ form, setForm }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log('handleChange called:', { name, value });
    setForm(prev => {
      const newForm = { ...prev, [name]: value };
      console.log('Updated form:', newForm);
      console.log('Required fields status:', {
        whyJoinCompany: !!newForm.whyJoinCompany,
        whenCanStart: !!newForm.whenCanStart,
        companyKnowledge: !!newForm.companyKnowledge
      });
      return newForm;
    });
  };

  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto', my: 4, p: 2 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          backgroundColor: '#ffffff', 
          mb: 3,
          border: '2px solid #1976d2',
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(25, 118, 210, 0.15)'
        }}
      >
        <Grid container spacing={3}>
          {/* Header Section */}
          <Grid item xs={12}>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                mb: 3,
                pb: 2,
                borderBottom: '2px solid #e3f2fd'
              }}
            >
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 'bold', 
                  color: '#1976d2',
                  fontSize: '1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <span>❓</span>
                Pertanyaan Tambahan
              </Typography>
            </Box>
            <Typography 
              variant="body1" 
              sx={{ 
                color: '#666', 
                mb: 3,
                fontStyle: 'italic',
                fontSize: '0.95rem'
              }}
            >
              Silakan jawab pertanyaan-pertanyaan tambahan berikut untuk melengkapi data pendaftaran Anda.
            </Typography>
          </Grid>

          {/* General Information */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>
                Informasi Umum
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth size="medium" required>
                    <InputLabel>Apakah anda mengijinkan Perusahaan menghubungi Lembaga Pendidikan atau Perusahaan di mana anda pernah berada?</InputLabel>
                    <Select 
                      name="allowContactInstitution"
                      value={form.allowContactInstitution || ''}
                      onChange={handleChange}
                      label="Apakah anda mengijinkan Perusahaan menghubungi Lembaga Pendidikan atau Perusahaan di mana anda pernah berada?"
                      required
                      sx={{ 
                        minWidth: 800,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="ya">Ya</MenuItem>
                      <MenuItem value="tidak">Tidak</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth size="medium" required>
                    <InputLabel>Adakah keluarga / saudara atau teman / kenalan anda bekerja pada Perusahaan kami?</InputLabel>
                    <Select 
                      name="hasRelativesInCompany"
                      value={form.hasRelativesInCompany || ''}
                      onChange={handleChange}
                      label="Adakah keluarga / saudara atau teman / kenalan anda bekerja pada Perusahaan kami?"
                      required
                      sx={{ 
                        minWidth: 800,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="ya">Ya</MenuItem>
                      <MenuItem value="tidak">Tidak</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {form.hasRelativesInCompany === 'ya' && (
                  <Grid item xs={12}>
                    <TextField 
                      label="Jika Ya, sebutkan nama dan jabatan-nya"
                      name="relativesInfo"
                      value={form.relativesInfo || ''}
                      onChange={handleChange}
                      fullWidth
                      size="medium"
                      variant="outlined"
                      placeholder="Nama - Jabatan"
                      required
                      sx={{
                        minWidth: 600,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>

          {/* Health & Education */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>
                Kesehatan & Pendidikan
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth size="medium" required>
                    <InputLabel>Apakah anda pernah menderita cacat jasmani (penglihatan, pendengaran, bicara, buta warna, jantung, dll)?</InputLabel>
                    <Select 
                      name="hasPhysicalDisabilities"
                      value={form.hasPhysicalDisabilities || ''}
                      onChange={handleChange}
                      label="Apakah anda pernah menderita cacat jasmani (penglihatan, pendengaran, bicara, buta warna, jantung, dll)?"
                      required
                      sx={{ 
                        minWidth: 800,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="ya">Ya</MenuItem>
                      <MenuItem value="tidak">Tidak</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {form.hasPhysicalDisabilities === 'ya' && (
                  <Grid item xs={12}>
                    <TextField 
                      label="Jika Ya, sebutkan"
                      name="disabilitiesInfo"
                      value={form.disabilitiesInfo || ''}
                      onChange={handleChange}
                      fullWidth
                      size="medium"
                      variant="outlined"
                      placeholder="Jelaskan cacat jasmani yang diderita"
                      required
                      sx={{
                        minWidth: 600,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <FormControl fullWidth size="medium" required>
                    <InputLabel>Apakah anda pernah menderita sakit keras atau kecelakaan?</InputLabel>
                    <Select 
                      name="hasSeriousIllness"
                      value={form.hasSeriousIllness || ''}
                      onChange={handleChange}
                      label="Apakah anda pernah menderita sakit keras atau kecelakaan?"
                      required
                      sx={{ 
                        minWidth: 800,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="ya">Ya</MenuItem>
                      <MenuItem value="tidak">Tidak</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {form.hasSeriousIllness === 'ya' && (
                  <Grid item xs={12}>
                    <TextField 
                      label="Jika Ya, kapan?"
                      name="illnessInfo"
                      value={form.illnessInfo || ''}
                      onChange={handleChange}
                      fullWidth
                      size="medium"
                      variant="outlined"
                      placeholder="Jelaskan kapan dan jenis sakit/kecelakaan"
                      required
                      sx={{
                        minWidth: 600,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <FormControl fullWidth size="medium" required>
                    <InputLabel>Apakah anda merencanakan untuk melanjutkan pendidikan dalam waktu dekat?</InputLabel>
                    <Select 
                      name="planContinueEducation"
                      value={form.planContinueEducation || ''}
                      onChange={handleChange}
                      label="Apakah anda merencanakan untuk melanjutkan pendidikan dalam waktu dekat?"
                      required
                      sx={{ 
                        minWidth: 800,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="ya">Ya</MenuItem>
                      <MenuItem value="tidak">Tidak</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {form.planContinueEducation === 'ya' && (
                  <Grid item xs={12}>
                    <TextField 
                      label="Jika Ya, dimana anda hendak melanjutkan pendidikan tersebut?"
                      name="educationPlanInfo"
                      value={form.educationPlanInfo || ''}
                      onChange={handleChange}
                      fullWidth
                      size="medium"
                      variant="outlined"
                      placeholder="Sebutkan institusi dan jurusan"
                      sx={{
                        minWidth: 600,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>

          {/* Organization Experience */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>
                Organisasi yang pernah saudara ikuti
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: 30, textAlign: 'center' }}>No</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: 200 }}>Nama Organisasi<br/>(Organization Name)</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: 120 }}>Tahun<br/>(Period)</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: 150 }}>Jabatan<br/>(Position)</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Typography variant="body2" sx={{ minWidth: 30, textAlign: 'center' }}>1</Typography>
                    <TextField 
                      name="organization1Name"
                      value={form.organization1Name || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Nama organisasi"
                      sx={{
                        minWidth: 200,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                    <TextField 
                      name="organization1Period"
                      value={form.organization1Period || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Contoh: 2019-2021"
                      sx={{
                        minWidth: 120,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                    <TextField 
                      name="organization1Position"
                      value={form.organization1Position || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Jabatan"
                      sx={{
                        minWidth: 150,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Typography variant="body2" sx={{ minWidth: 30, textAlign: 'center' }}>2</Typography>
                    <TextField 
                      name="organization2Name"
                      value={form.organization2Name || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Nama organisasi"
                      sx={{
                        minWidth: 200,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                    <TextField 
                      name="organization2Period"
                      value={form.organization2Period || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Contoh: 2019-2021"
                      sx={{
                        minWidth: 120,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                    <TextField 
                      name="organization2Position"
                      value={form.organization2Position || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Jabatan"
                      sx={{
                        minWidth: 150,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Typography variant="body2" sx={{ minWidth: 30, textAlign: 'center' }}>3</Typography>
                    <TextField 
                      name="organization3Name"
                      value={form.organization3Name || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Nama organisasi"
                      sx={{
                        minWidth: 200,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                    <TextField 
                      name="organization3Period"
                      value={form.organization3Period || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Contoh: 2019-2021"
                      sx={{
                        minWidth: 120,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                    <TextField 
                      name="organization3Position"
                      value={form.organization3Position || ''}
                      onChange={handleChange}
                      size="small"
                      variant="outlined"
                      placeholder="Jabatan"
                      sx={{
                        minWidth: 150,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Motivation & Work Availability */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>
                Motivasi & Ketersediaan Kerja
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField 
                    label="Mengapa anda ingin bekerja di Perusahaan kami?"
                    name="whyJoinCompany"
                    value={form.whyJoinCompany || ''}
                    onChange={handleChange}
                    fullWidth
                    size="medium"
                    variant="outlined"
                    multiline
                    rows={3}
                    placeholder="Jelaskan alasan anda ingin bergabung dengan perusahaan kami"
                    sx={{
                      minWidth: 600,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth size="medium">
                    <InputLabel>Bersediakan anda untuk melakukan pekerjaan diluar keahlian anda jika dibutuhkan oleh Perusahaan?</InputLabel>
                    <Select 
                      name="willingWorkBeyondExpertise"
                      value={form.willingWorkBeyondExpertise || ''}
                      onChange={handleChange}
                      label="Bersediakan anda untuk melakukan pekerjaan diluar keahlian anda jika dibutuhkan oleh Perusahaan?"
                      sx={{ 
                        minWidth: 800,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="ya">Ya</MenuItem>
                      <MenuItem value="tidak">Tidak</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {form.willingWorkBeyondExpertise === 'tidak' && (
                  <Grid item xs={12}>
                    <TextField 
                      label="Jika Tidak, sebutkan alasannya"
                      name="beyondExpertiseReason"
                      value={form.beyondExpertiseReason || ''}
                      onChange={handleChange}
                      fullWidth
                      size="medium"
                      variant="outlined"
                      placeholder="Jelaskan alasan tidak bersedia"
                      sx={{
                        minWidth: 600,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <TextField 
                    label="Kapan anda dapat mulai bekerja?"
                    name="whenCanStart"
                    value={form.whenCanStart || ''}
                    onChange={handleChange}
                    fullWidth
                    size="medium"
                    variant="outlined"
                    placeholder="Contoh: Segera / 1 minggu / 1 bulan"
                    sx={{
                      minWidth: 600,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    label="Apa yang anda ketahui tentang Perusahaan kami?"
                    name="companyKnowledge"
                    value={form.companyKnowledge || ''}
                    onChange={handleChange}
                    fullWidth
                    size="medium"
                    variant="outlined"
                    multiline
                    rows={3}
                    placeholder="Jelaskan apa yang anda ketahui tentang perusahaan kami"
                    sx={{
                      minWidth: 600,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Additional Information */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>
                Informasi Tambahan
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField 
                    label="Apakah ada informasi tambahan yang ingin anda sampaikan?"
                    name="additionalInfo"
                    value={form.additionalInfo || ''}
                    onChange={handleChange}
                    fullWidth
                    size="medium"
                    variant="outlined"
                    multiline
                    rows={3}
                    placeholder="Tambahkan informasi yang menurut anda penting untuk proses rekrutmen"
                    sx={{
                      minWidth: 600,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    label="Bagaimana anda mengetahui informasi lowongan ini?"
                    name="jobSource"
                    value={form.jobSource || ''}
                    onChange={handleChange}
                    fullWidth
                    size="medium"
                    variant="outlined"
                    placeholder="Contoh: LinkedIn, Website Perusahaan, Teman, Job Portal, dll"
                    sx={{
                      minWidth: 600,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    label="Harapan anda untuk posisi yang dilamar"
                    name="positionExpectations"
                    value={form.positionExpectations || ''}
                    onChange={handleChange}
                    fullWidth
                    size="medium"
                    variant="outlined"
                    multiline
                    rows={2}
                    placeholder="Jelaskan harapan dan target anda untuk posisi yang dilamar"
                    sx={{
                      minWidth: 600,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default Step6PertanyaanTambahan;
